import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { TableConfig } from '../../../shared/components/table/table.interfaces';
import { AssetManagementService } from '../asset-management-service';
import { VendorSummary } from '@app/shared/interfaces/vendor-stats';
import { ToastrService } from 'ngx-toastr';
import { VendorStatsCardEnum } from '@app/shared/constants/global.enum';
import { DateUtils, getMonthDateRange } from '@app/shared/utils/date.utils';
import { yearDateFormat } from '@app/shared/constants/dateFormat';

@Injectable({
  providedIn: 'root',
})
export class VendorStatsTableService {
  private readonly dataSubject = new BehaviorSubject<VendorSummary[]>([]);
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  private readonly selectedRowsSubject = new BehaviorSubject<VendorSummary[]>(
    [],
  );

  public readonly data$ = this.dataSubject.asObservable();
  public readonly loading$ = this.loadingSubject.asObservable();
  public readonly selectedRows$ = this.selectedRowsSubject.asObservable();

  public readonly tableConfig: TableConfig = {
    enableRowSelection: true,
    enableActions: true,
    enableSorting: true,
    enableFiltering: true,
    enableExport: true,
  };

  vendorSummaryData: VendorSummary[] = [];
  VendorStats = VendorStatsCardEnum;
  currentStartDate: string = '';
  currentEndDate: string = '';

  constructor(
    private assetManagementService: AssetManagementService,
    private toasterService: ToastrService,
  ) { }

  loadInitialData(): void {
    const { startDate, endDate } = getMonthDateRange(history.state.selectedMonth, yearDateFormat.date);
    this.currentStartDate = startDate;
    this.currentEndDate = endDate;
    this.getVendorSummaryData(this.currentStartDate, this.currentEndDate);
  }

  getVendorSummaryData(startDate: string, endDate: string): void {
    this.assetManagementService
      .getVendorSummaryData(startDate != "" ? startDate : this.currentStartDate, endDate != "" ? endDate : this.currentEndDate)
      .subscribe(
        (data) => {
          const vendorSummary = data.data;
          this.vendorSummaryData = this.transformVendorData(vendorSummary);
          this.dataSubject.next(this.vendorSummaryData);
        },
        (error) => {
          this.toasterService.error(this.VendorStats.vendorSummaryLoadError);
        },
      );
  }

  private transformVendorData(apiData: any): VendorSummary[] {
    if (!apiData || typeof apiData !== 'object') {
      return [];
    }

    return Object.keys(apiData).map((vendorName, index) => {
      const vendorStats = apiData[vendorName];

      return {
        vendorName: vendorName,
        vendorId: vendorStats.vendorId || 0,
        totalCount: vendorStats.totalCount || 0,
        onboardedCount: vendorStats.onboardedCount || 0,
        offboardedCount: vendorStats.offboardedCount || 0,
      };
    });
  }
}
